import { ScreenType } from '@tmdb-graphql-api/schema/types';
import { type StateCreator } from 'zustand';
import { type RecentlyWatchedStore, type State, type Store } from './types.ts';

export const createRecentlyWatchedStore: (
  initialState: Partial<State>,
) => StateCreator<Store, [], [], RecentlyWatchedStore> = initialState => (set, get) => ({
  addRecentlyWatchedMovie: (id: string) => {
    const { recentlyWatchedMovies } = get();

    if (recentlyWatchedMovies.includes(id)) {
      return;
    }

    set(state => ({
      recentlyWatchedMovies: [id, ...state.recentlyWatchedMovies],
    }));
  },
  addRecentlyWatchedTv: (id: string) => {
    const { recentlyWatchedTv } = get();

    if (recentlyWatchedTv.includes(id)) {
      return;
    }

    set(state => ({
      recentlyWatchedTv: [id, ...state.recentlyWatchedTv],
    }));
  },
  hasRecentlyWatched: () => {
    const { recentlyWatchedMovies, recentlyWatchedTv } = get();
    return recentlyWatchedMovies.length > 0 || recentlyWatchedTv.length > 0;
  },
  recentlyWatchedMovies: initialState.recentlyWatchedMovies ?? [],
  recentlyWatchedTv: initialState.recentlyWatchedTv ?? [],
  removeRecentlyWatched: (id: string, type: ScreenType) => {
    const { removeRecentlyWatchedMovie, removeRecentlyWatchedTv } = get();

    if (type === ScreenType.Movie) {
      removeRecentlyWatchedMovie(id);
    } else {
      removeRecentlyWatchedTv(id);
    }
  },
  removeRecentlyWatchedMovie: (id: string) => {
    const { recentlyWatchedMovies } = get();

    if (!recentlyWatchedMovies.includes(id)) {
      return;
    }

    set(state => {
      const index = state.recentlyWatchedMovies.indexOf(id);
      const newRecentlyWatchedMovies = state.recentlyWatchedMovies.toSpliced(index, 1);

      return {
        recentlyWatchedMovies: newRecentlyWatchedMovies,
      };
    });
  },
  removeRecentlyWatchedTv: (id: string) => {
    const { recentlyWatchedTv } = get();

    if (!recentlyWatchedTv.includes(id)) {
      return;
    }

    set(state => {
      const index = state.recentlyWatchedTv.indexOf(id);
      const newRecentlyWatchedTv = state.recentlyWatchedTv.toSpliced(index, 1);

      return {
        recentlyWatchedTv: newRecentlyWatchedTv,
      };
    });
  },
});
